import { combineReducers } from 'redux'

import menu from './menu'
import conteudo from './conteudo'
import conteudoGrupo from './conteudoGrupo'
import orgao from './orgao'
import links from './links'

export default combineReducers({
    menu,
    conteudo,
    conteudoGrupo,
    orgao,
    links,
})
